import React from 'react';
import { Wrench, Smartphone, Monitor, Settings, Laptop } from 'lucide-react';

interface LogoProps {
  variant?: 'light' | 'dark';
}

export default function Logo({ variant = 'dark' }: LogoProps) {
  return (
    <div className="flex items-center gap-2">
      {/* Text Content */}
      <div className="flex flex-col">
        <div className="flex items-center">
          <span 
            className={`text-2xl font-bold tracking-wider ${
              variant === 'light' ? 'text-white' : 'text-black'
            }`}
            style={{ 
              textShadow: '1px 1px 1px rgba(0,0,0,0.1)',
              fontFamily: "'Orbitron', sans-serif"
            }}
          >
            <span>TRAVIS</span>
            <span className="text-primary">TECH</span>
          </span>
          
          {/* Icons Group with increased spacing */}
          <div className="flex items-center ml-2 space-x-3">
            <Wrench 
              className={`w-5 h-5 ${
                variant === 'light' ? 'text-primary' : 'text-primary'
              }`}
            />
            <Monitor 
              className={`w-5 h-5 ${
                variant === 'light' ? 'text-primary' : 'text-primary'
              }`}
            />
            <Smartphone 
              className={`w-5 h-5 ${
                variant === 'light' ? 'text-primary' : 'text-primary'
              }`}
            />
            <Laptop 
              className={`w-5 h-5 ${
                variant === 'light' ? 'text-primary' : 'text-primary'
              }`}
            />
            <Settings 
              className={`w-5 h-5 animate-spin-slow ${
                variant === 'light' ? 'text-primary' : 'text-primary'
              }`}
            />
          </div>
        </div>
        <span 
          className={`text-xs tracking-wide mt-1 ${
            variant === 'light' ? 'text-gray-300' : 'text-gray-600'
          }`}
        >
          Remote Support, Mobile Repair, PC Troubleshooting & More
        </span>
      </div>
    </div>
  );
}